{
  "eyebrow": "Patvirtinkite planą",
  "title": "Peržiūrėkite ir sukonfigūruokite.",
  "sub": "Atsiskaitymo ciklą ar planą savo produktų linijoje galite pakeisti bet kada administratoriaus skydelyje. Perėjimas tarp Time ir Project derinamas su mūsų komanda.",
  "yourPlan": "Jūsų planas",
  "changePlan": "Keisti planą",
  "billing": "Atsiskaitymo ciklas",
  "billingMonthLabel": "Mokėti kas mėnesį",
  "billingMonthDesc": "Lankstu. Atšaukite bet kada.",
  "billingYearLabel": "Mokėti kasmet",
  "billingYearDesc": "15% nuolaida. Atsiskaitoma kartą per metus.",
  "addons": "Priedai",
  "addon": {
    "ssec": "Socialinis draudimas (check-in/out@work)",
    "ssecDesc": "Tik Belgija — automatinė Dimona deklaracija.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Tiesioginis GPS įmonės transporto priemonėms. +4,80 €/transporto priemonė/mėn.",
    "vehicles": "Transporto priemonės"
  },
  "users": {
    "title": "Kiek naudotojų jums reikia?",
    "help": "Kiekvienas asmuo, naudojantis Done-it, laikomas vienu naudotoju, įskaitant administratorius ir darbuotojus.",
    "active": "naudotojų"
  },
  "estimate": "Numatoma mėnesinė kaina",
  "estimateNote": "Be PVM. Mokate už čia nurodytą naudotojų skaičių ir vėliau galite jį pakeisti.",
  "estimateUnavailable": "Kainoraštis nepasiekiamas. Bandykite dar kartą, kad būtų įkelti naujausi kainos."
}
